"use client";

import React from "react";
import { PieChart, Pie, Cell } from "recharts";

const COLORS = ["#FFBB28", "#FF8042"];

export default function BasicPieChart({
  data = [],
  height = 200,
  width = 200,
}) {
  return (
    <PieChart width={width} height={height}>
      <Pie
        data={data}
        cx={100}
        cy={100}
        innerRadius={60}
        outerRadius={80}
        fill="#8884d8"
        paddingAngle={5}
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.color} />
        ))}
      </Pie>
    </PieChart>
  );
}
